"use client";
import { NavLink } from "react-router-dom";
import MetaLawyerLogoSVG from "../../systemDesign/MetaLawyerLogo";
import NavbarItemList from "../../../data/LandingDataList";
import MoriButton from "../../systemDesign/Buttons/MoriButton";

const LandingNavbar = () => {
  return (
    <div className="w-full text-white bg-black h-[64px] flex items-center py-4 px-6 justify-between fixed z-[99] border-b border-[#191919]">
      <div className="w-[1920px] mx-auto flex items-center justify-between">
        <div className="flex items-center gap-[91px]">
          <MetaLawyerLogoSVG width={148} height={35} />
          <div className="hidden lg:flex items-center gap-[34px]">
            {NavbarItemList.map((item) => (
              <NavLink
                to={item.link}
                key={item.id}
                className={({ isActive }) =>
                  `text-[14px] capitalize ${
                    isActive ? "text-[#0070F3]" : "text-[#8C8C8C]"
                  }`
                }
              >
                {item.text}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-[10px]">
          <MoriButton
            text="Contact"
            textCustomClass="!text-[14px] !text-white"
            customClass="!hidden md:!flex border-[1px]  border-stroke1 rounded-[6px] !w-[77px] !h-[32px]"
          />
          <MoriButton
            text="Log in"
            textCustomClass="!text-black !text-[14px]"
            customClass="!w-[77px] !bg-subColor5 !h-[32px]"
          />
        </div>
      </div>
    </div>
  );
};

export default LandingNavbar;
